import { useEffect, useState } from 'react';

const useRateLimitedRefresh = ({
  onRefresh,
  rateLimitSeconds,
}: {
  onRefresh: () => Promise<void>;
  rateLimitSeconds: number;
}) => {
  const [remainingSeconds, setRemainingSeconds] = useState(0);

  useEffect(() => {
    let intervalId: NodeJS.Timeout;
    if (remainingSeconds > 0) {
      intervalId = setInterval(() => {
        setRemainingSeconds((prevCount) => prevCount - 1);
      }, 1000);
    }

    return () => clearInterval(intervalId);
  }, [remainingSeconds]);

  const refreshScreeningResult = async () => {
    if (remainingSeconds > 0) {
      console.log('Attempted to refresh too soon');
      return;
    }

    await onRefresh();
    setRemainingSeconds(rateLimitSeconds);
  };

  return { refreshScreeningResult, remainingSeconds };
};

export default useRateLimitedRefresh;
